/**
 * Authentication service that uses OAuth2 Proxy
 */
class AuthService {
  /**
   * Get user information from the browser session
   * @returns {Promise<Object|null>} User information if available
   */
  async getUserInfo() {
      try {
        const response = await fetch('/oauth2/auth', {
          method: 'GET',
          credentials: 'include', // Include cookies
          headers: {
            'X-Auth-Request-Access-Token': 'true',
            'X-Auth-Request-User': 'true',
            'X-Auth-Request-Email': 'true',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          cache: 'no-store' // Prevent caching of authentication status
        });
        
        if (response.ok) {
          let email = response.headers.get('X-Auth-Request-Email');
          const user = response.headers.get('X-Auth-Request-User');
          
          // Store authorization header (ID token) and access token in session storage
          const idToken = response.headers.get('Authorization');
          const accessToken = response.headers.get('X-Auth-Request-Access-Token');
          
          if (idToken) {
            // Store ID token without 'Bearer ' prefix
            sessionStorage.setItem('id_token', idToken.replace('Bearer ', ''));
          }
          
          if (accessToken) {
            sessionStorage.setItem('access_token', accessToken);
          }
                 
          if (email || user) {
            return {
              name: user || email?.split('@')[0] || 'User',
              email: email || '',
              avatar: null
            };
          }
        }
      } catch (e) {
        // Silent fail for auth header fetch
      }
      
      // Fallback to basic info
      return {
        name: 'User',
        email: '',
        avatar: null
      };

  }

  /**
   * Sign in the user using OAuth2 Proxy
   */
  async signIn() {
    window.location.href = '/oauth2/start?rd=' + encodeURIComponent(window.location.origin + window.location.pathname);
  }

  /**
   * Sign out the user from OAuth2 Proxy and Okta
   * This is now a simple process where:
   * 1. Clear local session storage
   * 2. Redirect to server-side signout endpoint which handles token revocation and OAuth2 Proxy sign out
   */
  async signOut() {
    try {
      // Get the access token before clearing session storage
      const accessToken = sessionStorage.getItem('access_token');
      
      // Clear session storage
      sessionStorage.removeItem('id_token');
      sessionStorage.removeItem('access_token');
      
      // Build the signout URL with the access token as a query parameter if available
      let signoutUrl = '/signout';
      if (accessToken) {
        signoutUrl = `/signout?token=${encodeURIComponent(accessToken)}`;
      }
      
      // Redirect to signout endpoint with token in query string
      window.location.href = signoutUrl;
    } catch (error) {
      // Fallback - redirect to signout endpoint anyway
      window.location.href = '/signout';
    }
  }
}

// Export a singleton instance
const authService = new AuthService();
export default authService; 